module.exports = __webpack_public_path__ + "static/media/loading-spinner.84a8276e.svg";